import React from "react";
import "./TermsAndConditions.css";

interface TermsAndConditionsProps {
  onClose: () => void;
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ onClose }) => {
  return (
    <div className="terms-modal">
      <div className="terms-content">
        {/* Header Section */}
        <div className="terms-header">
          <h2>Terms and Conditions</h2>
          <button className="close-btn" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="terms-body">
          <p>
            Welcome to NepMaster.com! By accessing and using our services, you
            agree to the following terms and conditions. Please read them
            carefully before submitting your tracks.
          </p>

          <section>
            <h3>1. Overview of Services</h3>
            <p>
              NepMaster.com provides professional mastering services for audio
              tracks, delivering high-quality mastered files to users. For a fee
              of $5 per track, we deliver:
            </p>
            <ul>
              <li>A 44.1 kHz, 16-bit WAV file</li>
              <li>A 320 kbps MP3 file</li>
            </ul>
          </section>

          <section>
            <h3>2. Payment and Refund Policy</h3>
            <ul>
              <li>
                The cost of mastering a track is <strong>$5</strong> per track.
              </li>
              <li>
                All sales are final. Once a payment is made, no refunds will be
                issued under any circumstances.
              </li>
            </ul>
          </section>

          <section>
            <h3>3. User Consent and Data Usage</h3>
            <ul>
              <li>
                By submitting your audio track, you consent to NepMaster.com
                extracting MFCC (Mel-Frequency Cepstral Coefficient) features
                from your track. These features are used solely for audio
                analysis and mastering purposes.
              </li>
              <li>
                We do not share or distribute extracted data with third parties.
              </li>
            </ul>
          </section>

          <section>
            <h3>4. Creative Copyright and Liability</h3>
            <ul>
              <li>
                NepMaster.com holds no liability regarding the creative
                copyrights of your track.
              </li>
              <li>
                You, as the user, are solely responsible for ensuring you hold
                the necessary copyrights and permissions for the material you
                submit.
              </li>
              <li>
                NepMaster.com does not claim ownership of your original or
                mastered tracks.
              </li>
            </ul>
          </section>

          <section>
            <h3>5. Track Delivery Timeline</h3>
            <ul>
              <li>
                Mastered tracks will be available for download before{" "}
                <strong>12:00 PM EST</strong>. After this time, NepMaster.com
                will not store or provide access to submitted or mastered audio
                files.
              </li>
              <li>
                Users are responsible for downloading their files within the
                specified timeframe.
              </li>
            </ul>
          </section>

          <section>
            <h3>6. Submission Requirements</h3>
            <ul>
              <li>
                Each track submission must comply with the following
                specifications:
              </li>
              <li>
                Audio files should be properly formatted and uploaded in a
                supported file type.
              </li>
              <li>
                NepMaster.com reserves the right to refuse any submissions that
                do not meet our technical requirements.
              </li>
            </ul>
          </section>

          <section>
            <h3>7. Limitation of Liability</h3>
            <p>
              NepMaster.com provides mastering services on an "as-is" basis. We
              are not liable for any damages or losses resulting from the use of
              our services, including but not limited to technical issues, file
              corruption, or dissatisfaction with the mastered track.
            </p>
          </section>

          <section>
            <h3>8. Intellectual Property</h3>
            <p>
              By using our service, you acknowledge and agree that NepMaster.com
              does not guarantee any originality, protection, or enforcement of
              intellectual property rights in your mastered tracks.
            </p>
          </section>

          <section>
            <h3>9. Amendments</h3>
            <p>
              NepMaster.com reserves the right to update or amend these terms
              and conditions at any time without prior notice. Users are
              encouraged to review these terms periodically.
            </p>
          </section>

          <section>
            <h3>10. Contact</h3>
            <p>
              For any questions or concerns, please contact us at:
              <br />
              <strong>Email:</strong> support@nepmaster.com
            </p>
          </section>

          <p>
            By using NepMaster.com, you acknowledge that you have read,
            understood, and agree to abide by these terms and conditions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
